import(/* webpackMode: "eager" */ "/root/alex-booking-frontend/components/v3/AnimateOnScroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/Articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/Branches.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/CTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/CustomButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/ServiceHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/ServiceTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/alex-booking-frontend/components/v3/TwoImageCard.tsx");
;
import(/* webpackMode: "eager" */ "/root/alex-booking-frontend/node_modules/next/dist/client/image-component.js");
